import React from "react";
import styled from "styled-components";

import lo from "../assets/1.png";
import lo2 from "../assets/2.png";
import lo3 from "../assets/3.png";
import lo4 from "../assets/4.png";
import lo5 from "../assets/5.png";
import lo6 from "../assets/6.png";


const services = [

{
img:lo3,
title:"עובדי ניקיון וצוותי ניקיון",
text:"היכנסו למשרד בכל יום עם אווירה נעימה ומשרד נקי תוך ידיעה שאתם עובדים מול החברה המקצועית ביותר ובמחירים המשתלמים ביותר בכל הקשור לניקיון משרדים , צוותי הניקיון זמנים בכל שעות היממה לפי צרכיו של הלקוח"
},


{
img:lo2,
title:"קרצוף פוליש לרצפה ופוליש ווקס",
text:"אין צורך לדאוג לגבי נראות הרצפה – הפוליש שלנו הוא ברמה הגבוה ביותר ואנחנו נדאג שלא תוכלו לזהות את הרצפה לאחר הטיפול. המחיר שלנו הוא גם האטרקטיבי ביותר – ככה זה שאתם עובדים עם החברה המובילה ביותר"
},


{
img:lo,
title:"ניקיון ואחזקות נכסים מסחריים",
text:"ניקיון לאחר שיפוץ, ניקיון לפני איכלוס,  ניקיון משרדים, ניקיון בנייני משרדים ומסחריים,  שימוש בחומרים המובילים בשוק, שימוש במכשור מתקדם, מחירים הוגנים, אחריות מלאה על כל עבודה"
},


{
img:lo6,
title:"שירותי הנדימן לנכסים מסחריים",
text:" כל תיקון שצריך בבניין מסחרי / עסקי /  משרדי - אנחנו כאן לתיקונים קטנים ובינוניים וגדולים עם ידי זהב ויכולת לחדש ולתקן כמעט כל דבר שצריך. מקצועיות ואמינות. מחירים אטרקטיביים. יחס אישי של מנהל העסק. עמידה בלוחות זמנים. שירותים: ניסיון ומקצועיות, אמינות ודיוק, יחס אישי"
},


{
img:lo5,
title:"ניקיון שטחים פתוחים וציבוריים",
text:"חברתנו מספקת שירותי חצרנות על ידי חצרנים מקצועיים אשר מתמחים בניקיון שטחים פתוחים ובשימוש של מכונות ייעודיות לכל שטח בהתאמה"
},


{
img:lo4,
title:"  שירותי אחזקה באופן שוטף לנכסי מסחר / ציבורי",
text:"  שירותי האחזקה כוללים בין היתר-החלפת נורות וטיפול בחשבונות מים גבוהים חברתנו מספקת אב בית לפי צרכיו של הלקוח , טיפול במערכות הבניין השונות ותחזוקת כל בניין לפי צרכיו הייחודיים, אחזקת שוטפת של כל מערכות הבניין, משאבות, גנרטור-הפעלה חודשית וטיפול רבעוני, ספרינקלרים, רכזת כיבוי אש, מעליות, מערכת סולארית, ניקוי וחיטוי מאגרי מים, מפוחים, ניקיון המבנה, גינון ועוד"
}

];



const Section = styled.section`

width:100%;

min-height:100vh;

padding:100px 20px;


background:

radial-gradient(
circle at top,
#1b3555,
#050b14
);


direction:rtl;


`;




const Title = styled.h1`

color:white;

text-align:center;


font-size:

clamp(2rem,5vw,4rem);


font-weight:900;


margin-bottom:60px;


text-shadow:

0 0 20px #00aaff;


`;




const Grid = styled.div`

width:100%;

max-width:1200px;

margin:auto;


display:grid;


grid-template-columns:

repeat(3,1fr);


gap:35px;



@media(max-width:900px){

grid-template-columns:1fr;

}



`;




const Card = styled.div`

background:

rgba(255,255,255,.08);


backdrop-filter:blur(15px);


border-radius:30px;


padding:35px 25px;


text-align:center;


color:white;


border:

1px solid rgba(255,255,255,.2);



box-shadow:

0 0 30px rgba(0,150,255,.25);



transition:.3s;



&:hover{

transform:translateY(-8px);


box-shadow:

0 0 45px rgba(0,150,255,.6);

}




img{

width:130px;

height:130px;


object-fit:contain;


border-radius:50%;


background:white;


padding:10px;


margin-bottom:25px;


box-shadow:

0 0 20px rgba(255,255,255,.3);


}



h3{

font-size:1.4rem;


font-weight:900;


margin-bottom:15px;


}



p{

font-size:1.05rem;


line-height:1.8;


color:#f5f5f5;


}



@media(max-width:600px){


padding:25px 15px;


img{

width:110px;

height:110px;

}


h3{

font-size:1.2rem;

}


p{

font-size:1rem;

}


}



`;





export default function Services({reference}){


return(

<Section ref={reference}>


<Title id="השירותים שלנו"  >

השירותים שלנו

</Title>



<Grid>


{

services.map((item,index)=>(


<Card key={index}>


<img

src={item.img}

alt={item.title}

/>



<h3>

{item.title}

</h3>



<p>

{item.text}

</p>



</Card>


))

}



</Grid>



</Section>

);


}